import axios from 'axios';

// API base URL is baked from REACT_APP_BASE_URL at build time (dev docker
// build passes the dev API; CI/prod default to api.ipscore.app). Falls back to
// prod when unset. Trailing slash stripped to avoid `//path`.
// Exported because it is the ONE place the API origin is decided. Two call
// sites used to hard-code `https://api.ipscore.app` instead (the Telegram login
// check and the /t/ redirect), which meant a dev build still talked to
// production on those two paths no matter what REACT_APP_BASE_URL said — the
// kind of bug that only shows up as production data changing from a dev site.
export const API_BASE_URL = (
  process.env.REACT_APP_BASE_URL || 'https://api.ipscore.app'
).replace(/\/+$/, '');

// Create axios instance for API requests
export const apiAxios = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auth-service calls (sign-in, refresh, logout, key generation). Same origin as
// apiAxios, but `withCredentials` so the browser STORES the `access_token` /
// `refresh_token` cookies the auth-service sets and SENDS them back. Without it
// a cross-origin XHR (www.ipscore.app -> api.ipscore.app) silently drops
// Set-Cookie and the login session never exists. Data calls stay on apiAxios
// (Bearer api key, no cookies).
export const authAxios = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Standalone support service (ipscore-support) on its own subdomain. Base is
// REACT_APP_SUPPORT_URL (empty until the service is deployed → the SupportChat
// widget falls back to the legacy integrated api path). `withCredentials` lets
// the browser send the access_token cookie cross-origin for server-side
// identity resolution.
export const SUPPORT_BASE_URL = (
  process.env.REACT_APP_SUPPORT_URL || ''
).replace(/\/+$/, '');

export const supportAxios = axios.create({
  baseURL: SUPPORT_BASE_URL,
  withCredentials: true,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// No interceptors are registered here on purpose: most tests import this module
// for real, so it must stay free of side effects. The 401 key-recovery
// interceptor is installed at app bootstrap (src/index.tsx ->
// utils/auth/recoverApiKey).

